// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --modal-duration: 0.1s;
  }  
  
  .modal {
    position: fixed;
    z-index: 30;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    overflow-y: hidden;
    list-style: none;
  }
  
  .modalcontent-info {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    width: 650px;
    height: auto;
    background-color: white;
    box-shadow: 0 5px 8px 0 rgba(0, 0, 0, 0.2), 0 7px 20px 0 rgba(0, 0, 0, 0.17);
    animation-name: modalopen;
    animation-duration: var(--modal-duration);
    border-radius: 10px;
    
  }
  
  .modalbody-info ul {
    margin-top: 50px;
    display : contents;
  }
  
  .modalbody-info ul li {
    width: 250px;
    margin: 0 auto;
    text-align: left;
    padding-bottom: 5px;
    margin-bottom: 30px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.15);
    list-style: none;
  }

  @media (min-width: 801px) and (max-width: 1800px) {
    .modalcontent-info {      
      width : 500px;
      height : 600px;
      overflow: auto;
    }         
    .modalbody-info ul li {
      width: 200px;
    }
  }
  

  @media (max-width : 800px)  {
  .modalcontent-info {
    top : 40%;
    width : 300px;
    height: 470px;    
    overflow: auto;    
  }
}
  
  .modalheader img {
    margin-top: 50px;
    width: 150px;
    height: 150px;
    border-radius: 5px;
    border: 1px solid rgba(0, 0, 0, 0.15);
  }

  .modalbody-info {
    display : flex;
    flex-wrap : wrap;
    padding-top : 20px;    
  }
  

  .modalbody-info ul li #li-top{
    margin-top : 25px;
  }
 
  
  .modalfooter button {
    margin-top: 48px;
    width: 130px;
    height: 40px;
    border-radius: 5px;
    font-size : 14px;
  }
  .out_btn {
    margin-right: 10px;
    background-color: #ffcbcf;
  }
  .del_btn {
    margin-right: 10px;
    background-color: #f5e7e8;
  }

  .out_btn:hover {
    background-color: #b52929;
    transition: 0.3s all ease;
    color: white;
  }
  .del_btn:hover {
    background-color: #433c1b;
    transition: 0.3s all ease;
    color: white;
  }
  .yet_btn:hover {
    background-color: rgb(126, 126, 126);
    color: white;
    transition: 0.3s all ease;
  }
  
  @keyframes modalopen {
    from {
      
      opacity: 0;
    }
    to {
      
      opacity: 1;
    }
  }`, "",{"version":3,"sources":["webpack://./src/components/modal/AssetInfoModal.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,OAAO;IACP,MAAM;IACN,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,4EAA4E;IAC5E,yBAAyB;IACzB,yCAAyC;IACzC,mBAAmB;;EAErB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,4CAA4C;IAC5C,gBAAgB;EAClB;;EAEA;IACE;MACE,aAAa;MACb,cAAc;MACd,cAAc;IAChB;IACA;MACE,YAAY;IACd;EACF;;;EAGA;EACA;IACE,SAAS;IACT,aAAa;IACb,aAAa;IACb,cAAc;EAChB;AACF;;EAEE;IACE,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,qCAAqC;EACvC;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,kBAAkB;EACpB;;;EAGA;IACE,iBAAiB;EACnB;;;EAGA;IACE,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,yBAAyB;EAC3B;EACA;IACE,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;EACd;EACA;IACE,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;EACd;EACA;IACE,oCAAoC;IACpC,YAAY;IACZ,yBAAyB;EAC3B;;EAEA;IACE;;MAEE,UAAU;IACZ;IACA;;MAEE,UAAU;IACZ;EACF","sourcesContent":[":root {\n    --modal-duration: 0.1s;\n  }  \n  \n  .modal {\n    position: fixed;\n    z-index: 30;\n    left: 0;\n    top: 0;\n    height: 100%;\n    width: 100%;\n    overflow-y: hidden;\n    list-style: none;\n  }\n  \n  .modalcontent-info {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    text-align: center;\n    width: 650px;\n    height: auto;\n    background-color: white;\n    box-shadow: 0 5px 8px 0 rgba(0, 0, 0, 0.2), 0 7px 20px 0 rgba(0, 0, 0, 0.17);\n    animation-name: modalopen;\n    animation-duration: var(--modal-duration);\n    border-radius: 10px;\n    \n  }\n  \n  .modalbody-info ul {\n    margin-top: 50px;\n    display : contents;\n  }\n  \n  .modalbody-info ul li {\n    width: 250px;\n    margin: 0 auto;\n    text-align: left;\n    padding-bottom: 5px;\n    margin-bottom: 30px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n    list-style: none;\n  }\n\n  @media (min-width: 801px) and (max-width: 1800px) {\n    .modalcontent-info {      \n      width : 500px;\n      height : 600px;\n      overflow: auto;\n    }         \n    .modalbody-info ul li {\n      width: 200px;\n    }\n  }\n  \n\n  @media (max-width : 800px)  {\n  .modalcontent-info {\n    top : 40%;\n    width : 300px;\n    height: 470px;    \n    overflow: auto;    \n  }\n}\n  \n  .modalheader img {\n    margin-top: 50px;\n    width: 150px;\n    height: 150px;\n    border-radius: 5px;\n    border: 1px solid rgba(0, 0, 0, 0.15);\n  }\n\n  .modalbody-info {\n    display : flex;\n    flex-wrap : wrap;\n    padding-top : 20px;    \n  }\n  \n\n  .modalbody-info ul li #li-top{\n    margin-top : 25px;\n  }\n \n  \n  .modalfooter button {\n    margin-top: 48px;\n    width: 130px;\n    height: 40px;\n    border-radius: 5px;\n    font-size : 14px;\n  }\n  .out_btn {\n    margin-right: 10px;\n    background-color: #ffcbcf;\n  }\n  .del_btn {\n    margin-right: 10px;\n    background-color: #f5e7e8;\n  }\n\n  .out_btn:hover {\n    background-color: #b52929;\n    transition: 0.3s all ease;\n    color: white;\n  }\n  .del_btn:hover {\n    background-color: #433c1b;\n    transition: 0.3s all ease;\n    color: white;\n  }\n  .yet_btn:hover {\n    background-color: rgb(126, 126, 126);\n    color: white;\n    transition: 0.3s all ease;\n  }\n  \n  @keyframes modalopen {\n    from {\n      \n      opacity: 0;\n    }\n    to {\n      \n      opacity: 1;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
